module.exports = "<c4-input-slider-float\n\t[config]=\"config\"\n\t[name]=\"name\"\n\t[tagId]=\"tagId\"\n\t[precision]=\"precision\"\n\t[increment]=\"increment\"\n\t[min]=\"min\"\n\t[max]=\"max\"\n\t[value]='value'\n\t(valueChange)='valueChange.next($event)'>\n</c4-input-slider-float>"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/ui/src/app/directives/input/slider-integer/c4-input-slider-integer.html
// module id = 1648
// module chunks = 2